<template>
  <div>
    <!-- <van-nav-bar
      :title="$route.meta.title"
      left-text="返回"
      @click-left="$router.back()"
      left-arrow
      :fixed="true"
    /> -->
    <div class="evaluation-content-counter">
      <van-pull-refresh
        v-model="isLoading"
        :success-text="$t('successText')"
        :pulling-text="$t('pullingText')"
        :loosing-text="$t('loosingText')"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('noMore')"
          :loading-text="$t('loading')"
          @load="onLoad"
        >
          <div
            class="evaluation-survey-item"
            @click="handleReplyAnswer(item)"
            v-for="item in list"
            :key="item.id"
          >
            <img
              :src="item.cover || require('../../assets/noimg.jpeg')"
              alt=""
            />
            <div class="evaluation-survey-item-info">
              <div class="evaluation-name-status">
                <div class="survey-name">{{ item.name }}</div>
                <div class="survey-status">
                  {{
                    {
                      1: $t("progressStatus1"),
                      2: $t("progressStatus2"),
                      3: $t("progressStatus3"),
                    }[item.progress]
                  }}
                </div>
              </div>
              <div class="evaluation-time-status">
                <div class="survey-time">
                  {{
                    item.isUnlimited
                      ? $t("unlimit")
                      : $t("cutoff") + (item.endTime &&
                        item.endTime.substring(0, 10))
                  }}
                </div>
                <div class="survey-answer-status">
                  {{
                    item.isCommited
                      ? $t("progressStatus4")
                      : $t("progressStatus5")
                  }}
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
      loading: false,
      finished: false,
      customerId: "",
      shopId: "",
      pageQuery: {
        pageNo: 0,
        pageSize: 10,
      },
    };
  },
  mounted() {
    let roles = JSON.parse(localStorage.getItem("customerInfoList"));
    this.customerId =
      (roles && roles[0].customerId) || localStorage.getItem("customerId");
    this.shopId = localStorage.getItem("shopId");
  },
  methods: {
    // 下拉刷新
    onRefresh() {
      this.pageQuery.pageNo = 0;
      this.list = [];
      this.onLoad();
      this.isLoading = false;
    },
    async onLoad() {
      try {
        this.pageQuery.pageNo += 1;
        const { data: res } = await this.$authAjax.post(
          "/api/wxapp/survey/getCustomerSurveyList",
          {
            ...this.pageQuery,
            shopId: this.shopId,
            customerId: this.customerId,
          }
        );
        if (res?.data?.navigateLastPage >= this.pageQuery.pageNo) {
          this.list = [...this.list, ...res.data.list];
          this.loading = false;
        } else {
          this.finished = true;
        }
      } catch (e) {
        this.finished = true;
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    async handleReplyAnswer(item) {
      if (item.status == 3) {
        return this.$router.push({
          path: "/evaluation/explain",
          query: {
            type: "error",
          },
        });
      }
      if (item.progress == 2) {
        return this.$router.push({
          path: "/evaluation/explain",
          query: {
            type: "noStart",
          },
        });
      }
      if (item.progress == 3) {
        return this.$router.push({
          path: "/evaluation/explain",
          query: {
            type: "stop",
          },
        });
      }
      if (!item.isCommited) {
        await this.$authAjax.post("/api/wxapp/survey/incrPageView/" + item.id);
      }
      this.$router.push({
        path: "/evaluation/reply",
        query: {
          id: item.id,
          isPreview: item.isCommited ? 1 : 0,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.evaluation-content-counter {
  // margin-top: 45px;
  height: 100vh;
  overflow: auto;
  background: #f6f7f9;
  .evaluation-survey-item {
    padding: 12px;
    box-sizing: border-box;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    gap: 12px;
    background: #fff;
    img {
      width: 80px;
      height: 80px;
    }
    &-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 30px;
      .evaluation-name-status {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        .survey-name {
          font-size: 16px;
          color: #000;
          width: 150px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
        .survey-status {
          font-size: 15px;
          color: #333;
          white-space: nowrap;
        }
      }
      .evaluation-time-status {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .survey-time {
          font-size: 14px;
          color: #333;
        }
        .survey-answer-status {
          font-size: 14px;
          color: #333;
        }
      }
    }
  }
}
</style>
